import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { COMPRESSION_PILE, TENSION_PILE } from "../../../../constants.js";
import { selectLoadType, setLoadType } from "../../../../store/slices/aashtoSlice";

function LoadType({ readOnly = false }) {
  const { t } = useTranslation("translation");

  const dispatch = useDispatch();
  const loadType = useSelector(selectLoadType);

  function renderLoadType(val) {
    switch (val) {
      case COMPRESSION_PILE:
        return t("inner.compressionPile");
      case TENSION_PILE:
        return t("inner.tensionPile");
      default:
        break;
    }
  }

  function renderInput() {
    if (readOnly) {
      return <span className="input">{renderLoadType(loadType)}</span>;
    } else {
      return (
        <select
          className="change-input"
          onChange={(e) => {
            dispatch(setLoadType(e.target.value));
          }}
          name="loadType"
          id="loadType"
          value={loadType}
        >
          <option key={1} value={COMPRESSION_PILE}>
            {renderLoadType(COMPRESSION_PILE)}
          </option>
          <option key={2} value={TENSION_PILE}>
            {renderLoadType(TENSION_PILE)}
          </option>
        </select>
      );
    }
  }

  return <RowBody titleValue={<p>{t("inner.loadType")}</p>} inputValue={renderInput()} />;
}

export default LoadType;
